/**
 * eleven.js
 * JS for custom PRESS menu components (mega-menu-eleven, mobile-menu, etc.)
 */

(function () {
  /* ── Move mobile-menu into the header toggle wrapper ── */
  var menu = document.getElementById('mobile-menu');
  var toggle = document.querySelector('.mobile-toggle-wrapper');
  if (menu && toggle) {
    toggle.appendChild(menu);
  }

  if (!menu) return;

  var panelStack = ['root'];

  function showPanel(panelId) {
    var currentId = panelStack[panelStack.length - 1];
    var currentEl = menu.querySelector('[data-menu-panel="' + currentId + '"]');
    var nextEl    = menu.querySelector('[data-menu-panel="' + panelId + '"]');
    if (!nextEl) return;

    if (currentEl) {
      currentEl.classList.remove('mobile-menu__panel--active');
      currentEl.classList.add('mobile-menu__panel--left');
    }
    nextEl.classList.add('mobile-menu__panel--active');
    panelStack.push(panelId);
  }

  function goBack() {
    if (panelStack.length <= 1) return;

    var currentId = panelStack.pop();
    var prevId    = panelStack[panelStack.length - 1];
    var currentEl = menu.querySelector('[data-menu-panel="' + currentId + '"]');
    var prevEl    = menu.querySelector('[data-menu-panel="' + prevId + '"]');

    if (currentEl) currentEl.classList.remove('mobile-menu__panel--active');
    if (prevEl) {
      prevEl.classList.remove('mobile-menu__panel--left');
      prevEl.classList.add('mobile-menu__panel--active');
    }
  }

  function resetPanels() {
    var all = menu.querySelectorAll('.mobile-menu__panel');
    for (var i = 0; i < all.length; i++) {
      all[i].classList.remove('mobile-menu__panel--active', 'mobile-menu__panel--left');
    }
    var root = menu.querySelector('[data-menu-panel="root"]');
    if (root) root.classList.add('mobile-menu__panel--active');
    panelStack = ['root'];
  }

  /* ── Event delegation ── */
  menu.addEventListener('click', function (e) {
    /* Sub-menu card click */
    var card = e.target.closest('[data-submenu-target]');
    if (card) {
      e.preventDefault();
      e.stopPropagation();
      showPanel(card.getAttribute('data-submenu-target'));
      return;
    }
  });

  /* Back button — use capture phase so we intercept BEFORE the theme's
     onCloseButtonClick (which is bound directly on each <button>) fires. */
  menu.addEventListener('click', function (e) {
    var back = e.target.closest('[data-menu-back]');
    if (back) {
      e.preventDefault();
      e.stopImmediatePropagation();
      goBack();
    }
  }, true);

  /* Keyboard support for div-based cards */
  menu.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      var card = e.target.closest('[data-submenu-target]');
      if (card) {
        e.preventDefault();
        showPanel(card.getAttribute('data-submenu-target'));
      }
    }
  });

  /* Reset to root when the drawer closes */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'class' && !menu.classList.contains('active')) {
        setTimeout(resetPanels, 300);
        break;
      }
    }
  });
  observer.observe(menu, { attributes: true, attributeFilter: ['class'] });

  /* Also watch the parent <details> toggle wrapper */
  var toggleWrapper = menu.closest('.mobile-toggle-wrapper');
  if (toggleWrapper) {
    var wrapperObserver = new MutationObserver(function () {
      if (!toggleWrapper.classList.contains('active')) {
        setTimeout(resetPanels, 300);
      }
    });
    wrapperObserver.observe(toggleWrapper, { attributes: true, attributeFilter: ['class'] });
  }
})();

/* ── Mega Menu Eleven Small — position under trigger nav item ── */
(function () {
  var smallMenus = document.querySelectorAll('.mega-menu--small');
  if (!smallMenus.length) return;

  var menuButtons = document.querySelectorAll('.mega-menu-button');
  var allMegas    = document.querySelectorAll('.mega-menu');

  function positionSmallMenu(megaEl, btnEl) {
    if (!btnEl) return;
    var headerEl = document.querySelector('.header');
    var headerRect = headerEl ? headerEl.getBoundingClientRect() : { left: 0 };
    var btnRect = btnEl.getBoundingClientRect();
    var left = btnRect.left - headerRect.left;
    megaEl.style.left = left + 'px';
  }

  /* Build a map: for each .mega-menu--small, find its matching button */
  smallMenus.forEach(function (sm) {
    /* Find which index this small menu is within the full .mega-menu NodeList */
    var idx = -1;
    for (var i = 0; i < allMegas.length; i++) {
      if (allMegas[i] === sm) { idx = i; break; }
    }
    if (idx === -1 || !menuButtons[idx]) return;

    var btn = menuButtons[idx];

    /* Position on mouseenter (before the menu becomes visible) */
    btn.addEventListener('mouseenter', function () {
      positionSmallMenu(sm, btn);
    });

    /* Also position on click */
    btn.addEventListener('click', function () {
      positionSmallMenu(sm, btn);
    });

    /* Initial position in case it's already visible */
    positionSmallMenu(sm, btn);
  });
})();
